import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EditEmpresaService } from '../../../empresa/services/edit-empresa.service';
import { months } from '../../../reporte/modal-ventas/assets/date';
import { etiquetaProductoTexto } from '../../../empresa/utils/etiquetas-producto.util';

@Component({
    selector: 'app-view-empresa-modal',
    templateUrl: './view-empresa-modal.component.html',
})
export class ViewEmpresaModalComponent implements OnInit {
    @Input() empresaId: number;
    @Input() nombreRepresentante: string;

    empresa: any;
    isLoading = true;
    errorMessage: string | null = null;
    months = months;

    constructor(
        public activeModal: NgbActiveModal,
        private editEmpresaService: EditEmpresaService
    ) {}

    ngOnInit(): void {
        if (this.empresaId) {
            this.loadEmpresaData();
        } else {
            this.errorMessage = 'No se proporcionó un ID de empresa.';
            this.isLoading = false;
        }
    }

    async loadEmpresaData(): Promise<void> {
        this.isLoading = true;
        this.errorMessage = null;
        try {
            const empresaData =
                await this.editEmpresaService.getEmpresaActualAdministrador(
                    `agente-vigilado/${this.empresaId}`
                );

            if (empresaData) {
                this.empresa = {
                    id: empresaData.id,
                    nit: empresaData.nit,
                    razonSocial: empresaData.razonSocial,
                    tipoEmpresa: empresaData.tipoEmpresa,
                    tipoProducto: etiquetaProductoTexto(
                        empresaData.tipo_producto_que_importa
                    ),
                    eslabon: empresaData.eslabon,
                    telefono: empresaData.telefono,
                    correoElectronico: empresaData.correo_corporativo,
                    fechaRegistro: this.parsearFecha(empresaData.createdAt),
                    responsableInformacion: empresaData.representante ? `${empresaData.representante.nombre} ${empresaData.representante.apellido}` : 'No se encontró un representante asociado',
                };
            } else {
                this.errorMessage =
                    'No se encontró información para esta empresa.';
            }
        } catch (error) {
            console.error('Error al cargar los datos de la empresa:', error);
            this.errorMessage =
                'Ocurrió un error al cargar la información de la empresa.';
        } finally {
            this.isLoading = false;
        }
    }

    /**
     * Devuelve la fecha formateada en texto y en UTC-5 hora local (ejemplo: "10 de Febrero de 2026").
     */
    parsearFecha(fechaIso: string): string {
        const fecha = new Date(fechaIso);

        fecha.setHours(fecha.getHours() - 5);
        const dia = fecha.getDate().toString().padStart(2, '0');
        const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
        const monthObj = this.months.find((m) => m.number === Number(mes));
        const año = fecha.getFullYear();

        return `${dia} de ${monthObj.name} de ${año}`;
    }
}
